import React from "react";
import { Box, useBreakpointValue, VStack } from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {
  EffectCoverflow,
  Pagination,
  Navigation,
  Autoplay,
} from "swiper/modules";
import { HEXACO_EXPLORE_IMAGE_URLS } from "../data/hexacoData";

const HexacoCarousel: React.FC = () => {
  const isDesktop = useBreakpointValue({ base: false, md: true });

  return (
    <VStack w="100%" maxW="900px" mx="auto" spacing={4}>
      <Box w="100%" maxW={{ base: "100%", md: "80%" }} mx="auto">
        <Swiper
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          slidesPerView="auto"
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={{ clickable: true }}
          navigation={false}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
          className="coverflow-swiper"
          style={{ height: "100%", paddingBottom: "36px" }}
        >
          {HEXACO_EXPLORE_IMAGE_URLS.map((src, index) => (
            <SwiperSlide
              key={src}
              style={{ width: isDesktop ? "70%" : "85%", height: "100%" }}
            >
              <Box
                height="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="lg"
                overflow="hidden"
                boxShadow="xl"
              >
                <img
                  src={src}
                  alt={`HEXACO ${index + 1}`}
                  loading={index === 0 ? "eager" : "lazy"}
                  style={{
                    width: "100%",
                    height: "auto",
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </VStack>
  );
};

export default HexacoCarousel;
